export class CopyActivationLinkConfiguration {
  public userID: number;
  public userFullName: string;
  public organizationID: number;
}
